import Card from 'componentes/Card/Card';
import style from './Encontrados.module.scss';


const Encontrados = () => {
  

  return (
    <section className={style.container}>
      
      <h1 className={style.titulo}>Animais resgatados aguardando seu verdadeiro tutor</h1>

      <main className={style.cards}>
        <Card/>

        
      </main>
    </section>
   
  )
}

export default Encontrados;